(() => {
    const viewportHeight = window.innerHeight;

    function applyParallax(element) {
        const parallaxEffect = () => {
            const scrolled = document.documentElement.scrollTop;
            const relativeDistance = scrolled + viewportHeight - element.elementTop;
            const translation = Math.round(
                element.unitScroll * relativeDistance + element.start
            );
            element.style.transform = `translate3d(0, ${translation}px, 0)`;
        };

        element.handleParallax = () => {
            requestAnimationFrame(parallaxEffect);
        };

        window.addEventListener("scroll", element.handleParallax);

        return () => {
            window.removeEventListener("scroll", element.handleParallax);
            element.handleParallax = null;
        };
    }

    const parallaxElements = document.getElementsByClassName("js-parallax");

    const parallaxObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.removeParallax = applyParallax(entry.target);
            } else {
                if (entry.target.removeParallax) {
                    entry.target.removeParallax();
                    entry.target.removeParallax = null;
                }
            }
        });
    });

    for (const element of parallaxElements) {
        const [start, end] = element.dataset.parallax.split(",").map(Number);
        const distance = end - start;
        const unitScroll = distance / (viewportHeight + element.offsetHeight);

        let elementTop = 0;
        let currentElement = element;

        // Calculate the element's top position relative to the document
        while (currentElement) {
            elementTop += currentElement.offsetTop || 0;
            currentElement = currentElement.offsetParent;
        }

        element.start = start;
        element.unitScroll = unitScroll;
        element.elementTop = elementTop;

        parallaxObserver.observe(element);
    }

})();